/* global axios */
import ApiClient from '../ApiClient';

// V1 Admin Intelligence Bridge (Part 6) — thin client for the existing
// Nexceo::WorkforceTask + Nexceo::Ai::WorkforceTaskQueue (M26), exposed via
// WorkforceTasksController. No business logic here.
class NexceoWorkforceTasksAPI extends ApiClient {
  constructor() {
    super('nexceo/workforce_tasks', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  retry(id) {
    return axios.post(`${this.url}/${id}/retry`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }
}

export default new NexceoWorkforceTasksAPI();
